module.exports = __webpack_public_path__ + "static/01-2f067ad504ed41966452075fbbe34973.jpg";